<dx-scroll-view [ngClass]="{ printDialog: !disabled, printDialogDisabled: disabled }">
  <div class="print-container" fxLayout="row wrap" fxFill fxLayoutAlign="space-between" #printDialogContainer>
    <div fxFlex="52" fxFlex.xs="50">
      <mat-form-field appearance="fill" class="format" style="width: 98%">
        <mat-label>{{ res.get('Controls-Print-Template') }}</mat-label>
        <mat-select [(ngModel)]="this.selectedSelector" (selectionChange)="onTemplateChange()" name="format">
          @for (printTemplateSelector of this.printTemplateSelectors; track printTemplateSelector) {
            <mat-option [value]="printTemplateSelector">
              {{ printTemplateSelector.displayText }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="20" fxFlex.xs="50">
      <mat-form-field appearance="fill" class="scale" style="width: 95%">
        <mat-label>{{ res.get('Controls-Print-Measure') }}</mat-label>
        <mat-select [(ngModel)]="this.selectedScale" name="scale" (selectionChange)="onScaleChange($event.value)">
          @for (scale of this.selectedSelector?.printTemplate?.validScales; track scale) {
            <mat-option [value]="scale">
              {{ scale.displayText }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="20" fxFlex.xs="50">
      <mat-form-field appearance="fill" class="resolution" style="width: 95%">
        <mat-label>{{ res.get('Controls-Print-Resolution') }}</mat-label>
        <mat-select [(ngModel)]="this.selectedResolution" name="dpi">
          @for (resolution of this.selectedSelector?.printTemplate?.validResolutions; track resolution) {
            <mat-option
              [value]="resolution"
              >
              {{ resolution.displayText }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="8" fxFlex.xs="50" style="text-align: center">
      <button mat-raised-button [matTooltip]="res.get('Map-Print')" (click)="startPrinting()" class="buttonReady">
        <mat-icon [svgIcon]="res.svgName('Map-Print-Image')"></mat-icon>
      </button>
    </div>
    <!-- <div fxFlex="100">
    <mat-form-field class="mapComment">
      <mat-label>{{ res.get('Controls-Print-Title') }}</mat-label>
      <input matInput [(ngModel)]="comment" />
    </mat-form-field>
  </div> -->

  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
    <mat-form-field class="mapComment" fxFlex>
      <mat-label>{{ res.get('Controls-Print-Title') }}</mat-label>
      <input matInput [(ngModel)]="comment" />
    </mat-form-field>

    <button mat-icon-button [matTooltip]="'Features markieren/highlighten'" (click)="startMarkingFeatures()">
      <mat-icon>select_all</mat-icon>
    </button>
  </div>

  <div fxFlex="100">
    <mat-label class="stateText">{{ this.stateText }}</mat-label>
  </div>
  @if (hideProgress === false) {
    <mat-progress-spinner [mode]="modePS" [diameter]="50" class="progressSpinner">
    </mat-progress-spinner>
  }
</div>
</dx-scroll-view>
